// Utility functions for shared use across packages
/**
 * Generate a unique request ID for WebSocket messages
 */
export function generateRequestId() {
    return `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
/**
 * Check if a connection status indicates an active connection
 */
export function isConnected(status) {
    return status === 'connected';
}
/**
 * Check if a connection status indicates a transitional state
 */
export function isTransitioning(status) {
    return status === 'connecting' || status === 'disconnecting';
}
